import {
  getTableOptions,
  getTableRecords,
  getTableRecordsByFilter,
  getTableRecordsPage,
  removeTableRecord,
} from "../utils/api/tableApi";
import { getUserProfile } from "../utils/api/userApi";

export const fetchTableOptions = async (tableName) =>
  (await getTableOptions(tableName)).data;

export const fetchTableData = async (tableName) =>
  (await getTableRecords(tableName)).data;

export const fetchFilteredTableData = async (tableName, queryString) =>
  (await getTableRecordsByFilter(tableName, queryString)).data;

export const fetchTablePageData = async (tableName, pageNumber, queryString) =>
  (await getTableRecordsPage(tableName, pageNumber, queryString)).data;

export const fetchUserProfile = async () => (await getUserProfile()).data;

export async function deleteTableRecord(tableName, id) {
  const response = await removeTableRecord(tableName, id);

  return {
    status: response.status,
    payload: response.data,
  };
}
